import React from 'react';
import './index.css'; // Make sure to create this CSS file in your project.
import { useParams, useLocation} from 'react-router-dom';
import {configArrDto, features, partners} from "../../common/config";
import {useTranslation} from "react-i18next";


const FeatureDetailModule = ( ) => {
  let location = useLocation();
  const { t, i18n } = useTranslation();
  console.log('我看一眼', i18n.language);
  const modules = [...features, ...partners]
  const currentLang = i18n.language;
  {/*@ts-ignore*/}
  // const id = location.state.id;
  const { id } = useParams();
  const contentTsx =currentLang == 'zh' ?  modules?.find(item => item?.id == id)?.zh : modules?.find(item => item?.id == id)?.en
  return <div className={'detail-container'}>
    {contentTsx}
  </div>;
};

export default FeatureDetailModule;
